import { render, staticRenderFns } from "./CragRouteDescription.vue?vue&type=template&id=277fe522"
import script from "./CragRouteDescription.vue?vue&type=script&lang=js"
export * from "./CragRouteDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports